import { ReactNode } from 'react'

type GreyColumnProps = {
  label: string
  value: ReactNode
  className?: string
}

const GreyColumn = ({ label, value, className }: GreyColumnProps) => {
  if (!value && value !== 0) return null
  return (
    <div className={className}>
      <p className="typography-caption text-neutral-500">{label}</p>
      <p className="typography-body-l text-neutral-700 tracking-tight">{value}</p>
    </div>
  )
}

export default GreyColumn
